/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './chart-options-fields-modal.component.html';
import {UserProfileApiService} from '../../../admin/user-profile/user-profile-api.service';
import {LocalUserProfile} from '../../../../components/session/local-user-profile';

@Component({
  standalone: false,
  selector: 'adn-chart-options-fields-modal',
  template
})
export class ChartOptionsFieldsModalComponent implements OnInit {
  fields: any[] = [];
  availableFieldIds: string[] = [];
  chartType: string;
  profileParam: string;
  onSaved: () => void;

  selectedIds: string[] = [];

  constructor(
    public readonly bsModalRef: BsModalRef,
    @Inject(UserProfileApiService) private readonly UserProfile: UserProfileApiService,
    @Inject(LocalUserProfile) private readonly localUserProfile: any,
  ) {
  }

  ngOnInit(): void {
    this.selectedIds = (this.availableFieldIds || []).slice();
    if (!this.selectedIds.length) {
      this.selectedIds = _.map(this.fields, 'id');
    }
  }

  isSelected(fieldId: string): boolean {
    return this.selectedIds.indexOf(fieldId) > -1;
  }

  toggleField(fieldId: string, event: Event): void {
    const checked = !!(event.target as HTMLInputElement).checked;
    if (checked && this.selectedIds.indexOf(fieldId) < 0) {
      this.selectedIds = this.selectedIds.concat([fieldId]);
    } else if (!checked) {
      this.selectedIds = this.selectedIds.filter((id) => id !== fieldId);
    }
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  update(): void {
    const localUser = this.localUserProfile.get();
    const profile = localUser.profile || {};
    profile[this.profileParam] = {
      availableFields: this.selectedIds
    };
    firstValueFrom(this.UserProfile.saveProfile({
      id: localUser.userId,
      profile: _.pick(profile, this.profileParam)
    })).then((apiUser: any) => {
      this.localUserProfile.safeSaveProfile(this.profileParam, apiUser.profile[this.profileParam]);
      if (this.onSaved) {
        this.onSaved();
      }
      this.bsModalRef.hide();
    });
  }
}
